<template>
  <v-card>
    <div class="mx-4 my-4">
      <div
        v-if="completeProduct"
        class="text-left"
        style="font-size: 18px; font-weight: 700"
      >
        Sản phẩm gốc muốn chuyển đổi
      </div>
      <div v-else class="text-left" style="font-size: 18px; font-weight: 700">
        Chọn sản phẩm cần chuyển đổi
      </div>
      <div v-if="selectOriginalProduct && selectOriginalProduct.length > 0" class="ma-2 mt-6">
        <div
          v-for="(prod, idx) in selectOriginalProduct"
          :key="'modal prod' + idx"
          class="d-flex justify-space-between my-2"
        >
          <div>
            <v-checkbox
              :disabled="completeProduct"
              :id="'product' + prod.choice "
              v-model="prod.choice"
              :label="prod.labelProduct"
              class="custome-checkbox"
            ></v-checkbox>
          </div>
          <div>{{ prod.customer && prod.customer.fullName ? prod.customer.fullName : '' }}</div>
        </div>
      </div>
      <div v-else class="my-4" style="color: red; font-weight: 500">
        Không có sản phẩm nào thỏa mãn điều kiện chuyển đổi
      </div>
      <div class="danger-text">
        <v-icon color="#FF0000" class="mr-2"
          >mdi-information-slab-circle</v-icon
        >
        Lưu ý: Việc chuyển đổi sẽ tạo ra đơn hàng mới, sản phẩm gốc sẽ bị thu
        hồi toàn bộ khuyến mại, quota nghỉ phép/bảo lưu …
      </div>
      <div v-if="completeProduct">
        <div class="d-flex justify-space-between py-2">
          <div
            class="text-left my-auto"
            style="font-size: 16px; font-weight: 700"
          >
            Sản phẩm đích muốn chuyển đổi
          </div>
          <div>
            <div class="text-center">
              <v-menu :offset-y="true" top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    min-width="70"
                    height="32"
                    class="mr-0"
                    color="#AC0606"
                    :disabled="addProdDisable || (isReceipt && listProductReceipt.length > 0)"
                  >
                    <span style="font-size: 12px" class="mr-1">✢ </span>Thêm sản
                    phẩm
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item @click="addProduct('tutor')">
                    <v-list-item-title>Sản phẩm gia sư</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="addProduct('duo')">
                    <v-list-item-title>Sản phẩm khóa học</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="addProduct('combo')">
                    <v-list-item-title>Sản phẩm combo</v-list-item-title>
                  </v-list-item>
                  <v-list-item v-if="checkAuthorization('advanced-product-conversion_read')" @click="handleReceipt()">
                    <v-list-item-title>Biên nhận thanh toán</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
          </div>
        </div>
        <div class="danger-text d-flex align-center p-3" style="column-gap: 2px">
          <v-icon color="#FF0000" class="mr-2"
            >mdi-information-slab-circle</v-icon
          >
         <div>
           Hiện tại chỉ hỗ trợ up-sale lên 01 sản phẩm có giá trị cao hơn hoặc
           bằng số tiền đã đóng.
         </div>
        </div>
        <div
            id="style-2"
            v-if="isReceipt && listProductReceipt && listProductReceipt.length"
            style="height: 360px; overflow-y: auto"
        >
          <div class="d-flex align-center justify-space-between" style="column-gap: 20px;color: #279600; font-weight: 500;padding: 12px 12px 0px 12px">
            <div>Số tiền cọc còn lại chưa quy đổi: <span> {{ listReceipt && listReceipt.unusedReceiptAmount ? formatCurrencyNoD_C(listReceipt.unusedReceiptAmount) : 0 }} </span> đ</div>
            <div>Tổng tiền BNTT nhận được: {{ totalReceiptAmount ? formatCurrencyNoD_C(totalReceiptAmount) : 0 }} đ</div>
          </div>
          <v-row
              v-for="(product, indexProd) in listProductReceipt"
              :key="indexProd"
              class="mx-0"
          >
            <!--Sản phẩm gia sư-->
            <v-col
                v-if="product.type == 'tutor' || product.productType == 'sku_tutor'">
              <ReceiptTutorProduct
                  :product="product"
                  :index-prod="indexProd"
                  :order-id="detailOrder.orderId"
                  @productUpdated="handleProductUpdated"
              />
            </v-col>
            <!--Sản phẩm gia sư-->
            <!--Sản phẩm khóa học-->
            <v-col v-if="product.productType == 'sku_duo'">
              <ReceiptDuoProduct
                  :product="product"
                  :index-prod="indexProd"
                  :order-id="detailOrder.orderId"
                  @productUpdated="handleProductUpdated"
              />
            </v-col>
            <!--Sản phẩm khóa học-->
            <!--Sản phẩm combo-->
            <v-col v-if="product.productType == 'sku_combo'">
              <ReceiptComboProduct
                  :product="product"
                  :indexProd="indexProd"
                  :orderId="detailOrder.orderId"
                  @viewDetailCombo="viewDetailComboReceipt($event)"
                  @productUpdated="handleProductUpdated"
              />
            </v-col>
            <!--Sản phẩm combo-->
          </v-row>
        </div>

        <div
          id="style-2"
          v-if="selectGoalProducts && selectGoalProducts.length"
          style="height: 360px; overflow-y: auto"
        >
          <v-row
            v-for="(product, indexProd) in selectGoalProducts"
            :key="indexProd"
            class="mx-0"
          >
            <!--Sản phẩm gia sư-->
            <v-col
              v-if="product.type == 'tutor' || product.productType == 'sku_tutor'">
              <TutorProduct
                :product="product"
                :indexProd="indexProd"
                :curriculums="curriculums"
                :teacherTypes="teacherTypes"
                :curriculumObj="curriculumObj"
                :teacherTypeObj="teacherTypeObj"
                :classTypeObj="classTypeObj"
                :innerWidth="innerWidth"
                :childs="childs"
                :sortedChilds="sortedChilds"
                :skuTutors="skuTutors"
                @deleteProduct="deleteProduct($event)"
                @openCouponModal="openCouponModal($event)"
              />
            </v-col>
            <!--Sản phẩm gia sư-->

            <!--Sản phẩm khóa học-->
            <v-col v-if="product.type == 'duo'">
              <DuoProduct
                :product="product"
                :indexProd="indexProd"
                :childs="childs"
                :subjectObj="subjectObj"
                :levelObj="levelObj"
                :gradeObj="gradeObj"
                :activeTypeObj="activeTypeObj"
                :innerWidth="innerWidth"
                :sortedChilds="sortedChilds"
                :skuDuos="skuDuos"
                @deleteProduct="deleteProduct($event)"
                @openCouponModal="openCouponModal($event)"
              />
            </v-col>
            <!--Sản phẩm khóa học-->

            <!--Sản phẩm combo-->
            <v-col v-if="product.type == 'combo'">
              <ComboProduct
                :product="product"
                :indexProd="indexProd"
                :childs="childs"
                :skuCombos="skuCombos"
                :subjectObj="subjectObj"
                :innerWidth="innerWidth"
                :sortedChilds="sortedChilds"
                @deleteProduct="deleteProduct($event)"
                @openCouponModal="openCouponModal($event)"
                @viewDetailCombo="viewDetailCombo($event)"
              />
            </v-col>
            <!--Sản phẩm combo-->
          </v-row>
        </div>
        <div
          v-if="(listProductReceipt.length === 0 && isReceipt) || (!isReceipt && selectGoalProducts.length === 0)"
          class="d-flex w-100 justify-center align-center"
          style="height: 360px"
        >
          <div class="d-flex flex-column align-center">
            <svg
              width="58"
              height="50"
              viewBox="0 0 58 50"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M57.125 46.875V40.625H16.5V46.875H57.125ZM57.125 28.125V21.875H16.5V28.125H57.125ZM16.5 9.375H57.125V3.125H16.5V9.375ZM4 3.125V9.375H10.25V3.125H4ZM0.875 3.125C0.875 2.2962 1.20424 1.50134 1.79029 0.915292C2.37634 0.329241 3.1712 0 4 0H10.25C11.0788 0 11.8737 0.329241 12.4597 0.915292C13.0458 1.50134 13.375 2.2962 13.375 3.125V9.375C13.375 10.2038 13.0458 10.9987 12.4597 11.5847C11.8737 12.1708 11.0788 12.5 10.25 12.5H4C3.1712 12.5 2.37634 12.1708 1.79029 11.5847C1.20424 10.9987 0.875 10.2038 0.875 9.375V3.125ZM4 21.875V28.125H10.25V21.875H4ZM0.875 21.875C0.875 21.0462 1.20424 20.2513 1.79029 19.6653C2.37634 19.0792 3.1712 18.75 4 18.75H10.25C11.0788 18.75 11.8737 19.0792 12.4597 19.6653C13.0458 20.2513 13.375 21.0462 13.375 21.875V28.125C13.375 28.9538 13.0458 29.7487 12.4597 30.3347C11.8737 30.9208 11.0788 31.25 10.25 31.25H4C3.1712 31.25 2.37634 30.9208 1.79029 30.3347C1.20424 29.7487 0.875 28.9538 0.875 28.125V21.875ZM4 40.625V46.875H10.25V40.625H4ZM0.875 40.625C0.875 39.7962 1.20424 39.0013 1.79029 38.4153C2.37634 37.8292 3.1712 37.5 4 37.5H10.25C11.0788 37.5 11.8737 37.8292 12.4597 38.4153C13.0458 39.0013 13.375 39.7962 13.375 40.625V46.875C13.375 47.7038 13.0458 48.4987 12.4597 49.0847C11.8737 49.6708 11.0788 50 10.25 50H4C3.1712 50 2.37634 49.6708 1.79029 49.0847C1.20424 48.4987 0.875 47.7038 0.875 46.875V40.625Z"
                fill="#CCCCCC"
              />
            </svg>
            <div class="mt-2">
              <p
                class="mb-1 text-center"
                style="font-size: 12px; color: #776f6f"
              >
                Đơn hàng trống.
              </p>
              <p style="font-size: 12px; color: #776f6f">
                Ấn nút <strong>THÊM SẢN PHẨM</strong> để thêm sản phẩm vào đơn
                hàng
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex justify-center px-3 py-2 mt-4">
        <v-btn class="btn-blunk mr-3" outlined text @click="closeModal()">
          Huỷ
        </v-btn>
        <v-btn
          v-if="!completeProduct"
          class="btn-next"
          :disabled="checkActive"
          outlined
          text
          @click="nextStepSelectProd()"
        >
          Tiếp tục
        </v-btn>
        <v-btn
          v-else
          class="btn-next"
          outlined
          text
          :disabled="isDisableCreate || (totalReceiptAmount <= 0 && isReceipt)"
          @click="createOrder"
        >
          Tiếp tục
        </v-btn>
      </div>
    </div>
    <v-dialog
        v-if="isConfirmReceipt"
        v-model="isConfirmReceipt"
        persistent
        max-width="580"
    >
      <v-card>
        <v-card-title class="text-center" style="font-weight: 500"><strong>Xác nhận chuyển đổi thành biên nhận</strong></v-card-title>
        <v-card-text>
          <div style="color: #000;font-weight: 400; line-height: 1.5">
            Tổng số tiền được chuyển đổi thành biên nhận thanh toán là <span style="font-weight: 500;color: #279600">
            {{ totalReceiptAmount ? formatCurrencyNoD_C(totalReceiptAmount) : 0 }} đ</span>.
            <br> Sản phẩm sau khi được quy đổi thành Biên nhận thanh toán sẽ không thể thực hiện thanh toán thêm hay chuyển đổi sản phẩm khác.
          </div>
        </v-card-text>

          <v-card-actions style="display: flex; align-items: center; justify-content: center;column-gap: 12px">
            <v-btn
                style="background:#35B707; color: white ;width: 140px"
                outlined
                text
                @click="handleCreateReceipt()"
            >
             Xác nhận
            </v-btn>
            <v-btn style="background:#B70707; color: white;width: 140px" outlined text @click="isConfirmReceipt = false">
              Huỷ
            </v-btn>
          </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-if="isDetailCombo"
      v-model="isDetailCombo"
      persistent
      max-width="1000px">
      <DetailComboSubModule
        :productCombo="listProductCombo"
        :orderId="detailOrder.orderId"
        @onSavePrice="handleSavePriceCombo"
        :url-c-r-m="urlCRM"
      />
    </v-dialog>
  </v-card>
</template>

<script>
import TutorProduct from "../BlockProduct/TutorProduct";
import DuoProduct from "../BlockProduct/DuoProduct";
import ComboProduct from "../BlockProduct/ComboProduct";
import {addProduct_C, formatCurrencyNoD_C, verifyDataProduct, verifyDataProductReceipt} from "../HelperFunc";
import OrderRepository from "../../../../repositories/OrderRepository";
import {RECORD_TYPE} from "../../../../helpers/constants";
import ReceiptTutorProduct from "../PaymentReceipt/ReceiptTutorProduct.vue";
import ReceiptDuoProduct from "../PaymentReceipt/ReceiptDuoProduct.vue";
import ReceiptComboProduct from "../PaymentReceipt/ReceiptComboProduct.vue";
import DetailComboSubModule
  from "../../../../../vh-sub-modules/ShareModules/src/components/transfer-fee/DetailComboSubModule.vue";

export default {
  components: {
    DetailComboSubModule,
    ReceiptComboProduct,
    ReceiptDuoProduct,
    ReceiptTutorProduct,
    TutorProduct,
    DuoProduct,
    ComboProduct,
  },
  props: {
    skuCombos: {
      type: Array,
      required: () => [],
    },
    skuTutors: {
      type: Array,
      required: () => [],
    },
    skuDuos: {
      type: Array,
      required: () => [],
    },
    products: {
      type: Array,
      required: () => [],
    },
    childs: {
      type: Array,
      required: () => [],
    },
    detailOrder: {
      type: Object,
      required: () => {},
    },
    sortedChilds: {
      type: Array,
      required: () => [],
    },
    innerWidth: {
      type: Number,
      required: () => 0,
    },
    subjectObj: {
      type: Object,
      required: () => {},
    },
    activeTypeObj: {
      type: Object,
      required: () => {},
    },
    gradeObj: {
      type: Object,
      required: () => {},
    },
    levelObj: {
      type: Object,
      required: () => {},
    },
    classTypeObj: {
      type: Object,
      required: () => {},
    },
    teacherTypeObj: {
      type: Object,
      required: () => {},
    },
    curriculumObj: {
      type: Object,
      required: () => {},
    },
    teacherTypes: {
      type: Array,
      required: () => [],
    },
    curriculums: {
      type: Array,
      required: () => [],
    },
  },
  data() {
    return {
      isDetailCombo: false,
      listProductCombo: {
        items: [],
        name: null,
      },
      urlCRM: process.env.VUE_APP_API,
      completeProduct: false,
      selectOriginalProduct: [],
      selectGoalProducts: [],
      isReceipt: false,
      listProductReceipt: [],
      isConfirmReceipt: false,
      listReceipt: {}
    };
  },
  created() {
    this.selectOriginalProduct = _.cloneDeep(this.products);
  },
  computed: {
    totalReceiptAmount() {
      if (!this.listProductReceipt || this.listProductReceipt.length === 0) {
        return 0;
      }
      let total = this.listProductReceipt.reduce((total, product) => {
        let amount = 0;
        if (product.orderTypeProduct === 2) {
          amount = product.intoMoney || 0;
        } else if (product.orderTypeProduct === 1) {
          amount = product.intoMoneyDeposit || 0;
        }
        return parseInt(total) + parseInt(amount);
      }, 0);

      // const allProductsZeroAmount = this.listProductReceipt.every(product => {
      //   if (product.orderTypeProduct === 1) {
      //     return product.intoMoneyDeposit == 0
      //   } else if (product.orderTypeProduct === 2) {
      //     return product.intoMoney == 0
      //   }
      //   return false;
      // });
      if (this.listReceipt && this.listReceipt.unusedReceiptAmount !== null) {
        total += parseInt(this.listReceipt.unusedReceiptAmount);
      }
      // const hasDepositProduct = this.listProductReceipt.some(product => product.orderTypeProduct === 1);
      // if (allProductsZeroAmount && this.listReceipt && this.listReceipt.unusedReceiptAmount !== null) {
      //   total += parseInt(this.listReceipt.unusedReceiptAmount);
      // }else if (hasDepositProduct && this.listReceipt && this.listReceipt.unusedReceiptAmount !== null) {
      //   total += parseInt(this.listReceipt.unusedReceiptAmount);
      // }

      return total;


    },
    addProdDisable() {
      return !!this.selectGoalProducts.length;
    },
    checkActive() {
      const check = this.selectOriginalProduct.some((item) => item.choice);
      return !check;
    },
    isDisableCreate() {
      if(!this.isReceipt) {
        return this.selectGoalProducts.find(item => item.productId) ? false : true;
      }else if(this.isReceipt) {
        return this.listProductReceipt.length === 0 || this.listProductReceipt === null;
      }else {
        return false
      }
    },
    formatDataOrder() {
      let totalPrice = 0;
      if(this.selectGoalProducts && this.selectGoalProducts.length) {
        return this.selectGoalProducts.map((item) => {
          totalPrice += ((item.price * item.count) - item.discount);
          if (totalPrice < 0) totalPrice = 0;
          const campaigns = item.campaigns.map((itemC) => {
            return {
              code: itemC.code,
              type: itemC.type,
              giftIndexes: itemC.giftIndex >= 0 ? [itemC.giftIndex] : [],
              promotionSubCode: itemC.raw.promotionSubCode ? itemC.raw.promotionSubCode : null,
            };
          });
          return {
            orderType: item.isNew ? 1 : 2,
            productId: item.productId,
            productType: `sku_${item.type}`,
            quantity: item.count,
            customerId: item.customerId,
            activeType: item.activeType,
            price: item.price,
            intoMoney: ((item.price * item.count) - item.discount) > 0 ? ((item.price * item.count) - item.discount) : 0,
            campaigns,
          };
        });
      }
      return []
    },
  },
  watch: {
    listProductReceipt: {
      handler(newVal, oldVal) {
        this.$forceUpdate();
      },
      deep: true
    }
  },
  mounted() {
    this.$forceUpdate();
  },
  methods: {
    totalReceiptComboAmount(listProduct) {
      if (!listProduct || listProduct.length === 0) {
        return 0;
      }
      return listProduct.reduce((total, product) => {
        let amount = 0;
        if (this.listProductCombo.orderTypeProduct === 2) {
          amount = product.intoMoney || 0;
        } else if (this.listProductCombo.orderTypeProduct === 1) {
          amount = product.intoMoneyDeposit || 0;
        }
        return parseFloat(total) + parseFloat(amount);
      }, 0);
    },
    handleSavePriceCombo(productId) {
      const totalReceiptAmount = this.totalReceiptComboAmount(this.listProductCombo.items);
      const comboProduct = this.listProductReceipt.find(item => item.productId === productId);
      if(this.listProductCombo.orderTypeProduct === 2) {
        comboProduct.intoMoney = totalReceiptAmount;
      } else if(this.listProductCombo.orderTypeProduct === 1) {
        comboProduct.intoMoneyDeposit = totalReceiptAmount;
      }
      this.isDetailCombo = false;
    },
    formatCurrencyNoD_C,
    async handleReceipt() {
      const selectedProducts = this.selectOriginalProduct.filter(item => item.choice);
      const regularProducts = selectedProducts.filter(item => item.orderProductId);
      const comboProducts = selectedProducts.filter(item => !item.orderProductId);
      const orderProductIds = regularProducts.map(product => product.orderProductId);

      const combosArray = comboProducts.map(combo => combo.comboId + '_' + combo.customerId);
      const params = {
        orderProductIds: orderProductIds,
        combos: combosArray,
        orderId: this.detailOrder.orderId,
      };
      try {
        const response = await OrderRepository.getProductToPaymentReceiptApi(params)
        if (response.success && response.data) {
          this.isReceipt = true
          this.listReceipt= response.data;
          const listProductToPaymentReceipt = response.data && response.data.orderProducts ? response.data.orderProducts : []
          this.listProductReceipt = listProductToPaymentReceipt.map(item => {
            return {
              ...item,
              orderTypeProduct: item.isComplete ? 2 : 1,
              isEdit: false,
              isEditTransfer: false,
            }
          })
        } else {
          this.isReceipt = false
          this.listProductReceipt = []
        }
      } catch (e) {
        console.log(e)
      }
    },
    showChild(data) {
      const child = this.childs.find(
          (item) => item.customerId === data.customerId
      );
      if (child) {
        return child.fullName;
      }
      return "Chưa xác định";
    },
    closeModal() {
      this.completeProduct = false;
      this.$emit("close");
    },
    nextStepSelectProd() {
      this.completeProduct = true;
      // if (
      //   this.$store.state.module.schoolLevelId === 1 &&
      //   (this.$store.state.module.typeId == 1 ||
      //     this.$store.state.module.typeId == 3)
      // ) {
      //   addProduct_C(this.selectGoalProducts, 'duo', this.skuDuos);
      // } else {
      //   addProduct_C(this.selectGoalProducts, 'tutor', this.skuTutors);
      // }
    },
    addProduct(type = "tutor") {
      this.isReceipt = false
      this.listProductReceipt = []
      let listSKU = [];
      if (type === "tutor") listSKU = this.skuTutors;
      if (type === "duo") listSKU = this.skuDuos;
      if (type === "combo") listSKU = this.skuCombos;
      addProduct_C(this.selectGoalProducts, type, listSKU)
    },
    deleteProduct(data) {
      this.selectGoalProducts.splice(data.index, 1);
    },
    openCouponModal(data) {
      console.log(data);
      this.$emit("openCouponModal", data);
    },
    viewDetailCombo(data) {
      this.$emit("viewDetailCombo", data);
    },
    viewDetailComboReceipt(data) {
      this.listProductCombo = data;
      if(data && data.items.length > 0) {
        this.listProductCombo.items = data.items.map(item => {
          return {
            ...item,
            isEdit: false,
            isEditTransfer: false,
            originalNumberLessonTransfer: item.numberLessonTransfer,
            originalIntoMoney: item.intoMoney,
            originalIntoMoneyDeposit: item.intoMoneyDeposit,
            originalOrderTypeProduct: item.orderTypeProduct,
          }
        });
      }else {
        this.listProductCombo.items = [];
      }
      this.isDetailCombo = true;
    },
    async handleUpSale() {
      const verify = verifyDataProduct(this, this.selectGoalProducts);


      if (verify) return
      const loading = this.$loading.show();
      const selectedProducts = this.selectOriginalProduct.filter(item => item.choice);

      const regularProducts = selectedProducts.filter(item => item.orderProductId);
      const comboProducts = selectedProducts.filter(item => !item.orderProductId);

      const oldOrderProducts = regularProducts.map(product => ({
        orderProductId: product.orderProductId
      }));

      // Format old combos
      const oldCombos = comboProducts.map(combo => ({
        comboId: combo.comboId,
        customerId: combo.customerId,
        productType: combo.productType
      }));
      const data = {
        oldOrderId: this.detailOrder.orderId,
        oldOrderProducts: oldOrderProducts,
        oldCombos: oldCombos,
        products: this.formatDataOrder
      };

      try {
        const response = await OrderRepository.createUpsaleDraftApi(data)
        if (response.success) {
          const idUpsaleDraft = response.data && response.data._id ? response.data._id : null;
          let route = this.$router.resolve({
            name: "CreateOrderNew",
            params: {
              id: this.$route.params.id,
            },
            query: {
              record_id: idUpsaleDraft,
              record_type: RECORD_TYPE.UPSALE,
            }
          });
          window.open(route.href, '_self')
        }
      } catch (e) {
        console.log(e)
      } finally {
        loading.hide()
      }
    },
    async handleCreateReceipt() {
      const listProducts = this.listProductReceipt.map(product => {
        const cleanProduct = { ...product };
        // eslint-disable-next-line no-prototype-builtins
        cleanProduct.intoMoney = parseInt(product.intoMoney);
        cleanProduct.intoMoneyDeposit = parseInt(product.intoMoneyDeposit);
        cleanProduct.priceType = parseInt(product.orderTypeProduct);
        if (cleanProduct.hasOwnProperty('isEdit')) {
          delete cleanProduct.isEdit;
        }
        if (cleanProduct.hasOwnProperty('isEditTransfer')) {
          delete cleanProduct.isEditTransfer;
        }
        if (cleanProduct.hasOwnProperty('orderTypeProduct')) {
          delete cleanProduct.orderTypeProduct;
        }
        return cleanProduct;
      });
      const data = {
        orderId: this.detailOrder.orderId,
        totalPaymentReceiptAmount: this.totalReceiptAmount,
        unusedReceiptAmount: this.listReceipt.unusedReceiptAmount,
        orderProducts: listProducts,
      }
      const response = await OrderRepository.createProductToPaymentReceiptApi(data);
      if(response.success) {
        this.isConfirmReceipt = false;
        this.isReceipt = false;
        this.$emit('createReceipt', response);
        this.$swal({
          icon: 'success',
          text: 'Chuyển đổi biên nhận thành công.',
          timer: 3000,
        })
      } else {
        this.isConfirmReceipt = false;
        this.$swal({
          icon: 'error',
          text: 'Chuyển đổi biên nhận thanh toán thất bại.',
          timer: 3000,
        })
      }
    },
    handleProductUpdated(data) {
      if (data && data.product && data.index !== undefined) {
        this.listProductReceipt[data.index] = data.product;
        this.$forceUpdate();
      }
    },
    async createOrder() {
      if (this.isReceipt && this.listProductReceipt.length) {
        const verify = verifyDataProductReceipt(this, this.listProductReceipt);
        console.log(verify, 'verify data')
        if (verify) return
            this.isConfirmReceipt= true
      } else {
        await this.handleUpSale();
      }
    },
  }
};
</script>
<style lang="scss" scoped>
.btn-blunk {
  background-color: #fff !important;
  color: #333333 !important;
  border: 1px solid #333333 !important;
  border-radius: 999px !important;
}
.btn-next {
  background-color: #fff !important;
  color: #ff5500 !important;
  border: 1px solid #ff5500 !important;
  border-radius: 999px !important;
}
.btn-next.v-btn--disabled {
  background-color: #fff !important;
  color: #dadada !important;
  border: 1px solid #dadada !important;
}
.danger-text {
  color: #ff0000;
  border-radius: 20px;
  background-color: #ff550026;
  padding: 6px 8px;
  margin: 4px 0px;
}
</style>
<style lang="scss">
.custome-checkbox {
  margin-top: 0px !important;
  padding-top: 0px !important;
  .v-messages {
    display: none !important;
  }
}
</style>